/**
 * The store's listener middleware: side effects that follow actions (saving
 * filters after a change), so they never run from a component effect.
 * Features register their listeners on it.
 */
import { createListenerMiddleware } from '@reduxjs/toolkit';

export const listenerMiddleware = createListenerMiddleware();
